import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    LOGIN_MUTATION,
    ME_QUERY,
    CREATE_USER_MUTATION,
    UPDATE_USER_MUTATION,
    CHANGE_PASSWORD_MUTATION,
    CHANGE_MY_PASSWORD_MUTATION,
    DELETE_USER_MUTATION
} from "@/graphql/user.js";

const token = localStorage.getItem("token");
const me = JSON.parse(localStorage.getItem("me"));

const state = {
    token: token,
    me: me
};
const getters = {
    isLoggedIn: state => !!state.token
};
const mutations = {
    [types.LOGIN](state) {
        state.token = localStorage.getItem("token") || "";
    },
    [types.LOGOUT](state) {
        state.token = "";
        state.me = null;
    },
    [types.SET_ME](state, me) {
        state.me = me;
    }
};
const actions = {
    async login(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: LOGIN_MUTATION,
                    variables: {
                        email: payload.email,
                        password: payload.password
                    }
                })
                .then(response => {
                    const token = response.data.tokenAuth.token;

                    // save token to local storage
                    localStorage.setItem("token", token);
                    context.commit(types.LOGIN);

                    //   console.log("login succeed! ", token);
                    resolve();
                })
                .catch(error => {
                    localStorage.removeItem("token");

                    console.log("login failed!", error);
                    reject(error);
                });
        });
    },

    async logout(context) {
        return new Promise(resolve => {
            // localStorage.removeItem("token");
            localStorage.clear();
            context.commit(types.LOGOUT);
            resolve();
        });
    },

    async fetchMe(context) {
        const response = await apolloClient.query({
            query: ME_QUERY,
            fetchPolicy: "network-only"
        });
        localStorage.setItem("me", JSON.stringify(response.data.me));
        context.commit(types.SET_ME, { ...response.data.me });
    },

    async createUser(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_USER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const user = response.data.createUser.user;

                    resolve(user);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateUser(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_USER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const user = response.data.updateUser.user;

                    resolve(user);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async changePassword(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CHANGE_PASSWORD_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const user = response.data.changePassword.user;

                    resolve(user);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async changeMyPassword(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CHANGE_MY_PASSWORD_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const user = response.data.changeMyPassword.user;

                    resolve(user);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteUser(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_USER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const user = response.data.deleteUser.user;

                    resolve(user);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
